import { render, staticRenderFns } from "./lesson-add-or-update.vue?vue&type=template&id=10fce727&"
import script from "./lesson-add-or-update.vue?vue&type=script&lang=js&"
export * from "./lesson-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports